module.exports = __webpack_public_path__ + "media/images/about/2-a4aca4ba02635ddeae6856257de19c89.jpg";